import React, { useEffect } from "react";

// Import your components
import Getapp from "./Getapp";
import Services from "./Services";
import Maamaasmoment from "./Maamaasmoment";
import Toptobottom from "./Toptobottom";
import Appinformation from "./Appinformation";
import MainBanner from "./MainBanner";
import Ourclints from "./Ourclints";
import Faqs from "./Faqs";
import Homegeleery from "./Homegeleery";
import Footer from "./Footer";
import Authservice from '../Component/Auth/Authservice'
const Login = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: "white", overflowY: "auto", height: "100vh" }}>
      <Authservice />
      <Homegeleery />
      <Ourclints />
      <Getapp />
      <Faqs />
      <Appinformation />
      {/* Optional: Uncomment if needed later */}
      {/* <Homesliderdata /> */}
      {/* <AllvariousCards /> */}
      {/* <Homesecondslidercards /> */}
      {/* <HoveredCards /> */}
      <Toptobottom />
      <Footer />
    </div>
  );
};

export default Login;
